/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Filters from "../Filters";
import { ControlTable } from "../Table";
import { getParams } from "../../utils/params";
import { getDay, getYear } from "../../utils/date";
import systemAlert from "../../utils/systemAlert";
import useForm from "../../hooks/useForm";
import { CARE_COMPANY_MEMO_COMPLETED, CARE_COMPANY_MEMO_FILTER_COMPLETED } from "../../constants/CARE_COMPANY";
import { getCompanyManagerSchedules, removeCompanyManagerSchedule } from "../../apis/admin/companies";

const CareCompanyScheduleList = ({
  company,
  managerCompany,
  setSchedule,
  toggle,
  setToggle,
  setFormType,
}) => {
  const [fields] = useState([
    { title: "작업일", key: "date" },
    { title: "제목", key: "title" },
    {
      title: "내용",
      key: "content",
      onValue: (value) => {
        const data = (String(value) || "").replace(/<[^>]*>?/g, '');
        if (data.length > 10) {
          return <>{data.slice(0, 10) + '..'}</>;

        } else {
          return <>{data}</>;
        }
      }
    },
    /*
    {
      title: "작성자",
      key: "writerEmployeeIdx",
      type: 'profile'
    },
    */
    {
      title: "처리여부",
      key: "completed",
      onValue: (value) => {
        const data = CARE_COMPANY_MEMO_COMPLETED.find((e) => e.value === String(value));
        if (data) {
          return data.label;
        } else {
          return '';
        }
      }
    },
    {
      title: '작성일',
      key: 'createdTime',
      type: 'date'
    }
  ]);

  const getCalendarData = (form) => {
    setIsLoading(true);
    getCompanyManagerSchedules(managerCompany.companyIdx, company.companyIdx, getParams(form))
      .then((res) => {
        setList(res.data.schedules);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => {
        setIsLoading(false);
      });
  };


  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    reSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: {},
      range: {
        date: [getYear(1), getDay()]
      },
      order: [{
        date: 'desc'
      }],
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    if (company && managerCompany) {
      getCalendarData(form);
      setSubmit(getCalendarData);
    }
  }, [company, toggle]);

  const [filters] = useState([
    {
      title: "날짜",
      key: 'range.date',
      type: "customdatepicker",
    },
    {
      title: "제목 검색",
      type: "input",
      key: "search.title",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "처리여부",
      type: "select",
      key: "search.completed",
      options: {
        list: CARE_COMPANY_MEMO_FILTER_COMPLETED,
      },
    },
  ]);

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setSchedule(data);
          setFormType("modify");
          setToggle(true);
        },
      },
      {
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert(`"${company.name}" 일정을 삭제하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                color: 'red',
                onClick: () => {
                  setIsLoading(true);
                  removeCompanyManagerSchedule(managerCompany.companyIdx, company.companyIdx, data.idx)
                    .then((res) => {
                      reSubmit();
                    })
                    .finally(() => {
                      setIsLoading(false);
                    });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const onRowClick = (data, e) => {
    setSchedule(data);
    setFormType("view");
    setToggle(true);
  };

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        isControl={false}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        rowBtn={rowBtnConfig}
        onSelect={onRowClick}
        submit={handleSubmit}
      />
    </>
  );
};

export default CareCompanyScheduleList;
